<template>
  <el-row
    v-loading.fullscreen.lock="fullscreenLoading"
    class="main-container">
    <el-col
      :sm="8"
      :lg="7"
      :xl="6"
      class="client-main-list">
      <customers-list
        :key="keyList"
        :customers-items="customers"
        :is-loading="loading"
        @onEdit="onEdit"
        @onAssignBranch="onAssignBranch"
        @onAssign="onAssign"
        @onReassign="onReassign"
        @onCreate="onCreate"
        @onFuse="onFuse"
        @onDelete="onDelete"/>
    </el-col>
    <el-col
      :sm="16"
      :lg="17"
      :xl="18"
      class="container-section-main">
      <customers-header-stick
        :on-visible="showStick"
        :customer-current="currentCustomer"/>
      <div
        class="client-main-section"
        @scroll="scrollEvent">
        <el-row>
          <el-col :span="24">
            <customers-header :client-current="customer"/>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <customers-tabs @isCreate="onCreate"/>
          </el-col>
        </el-row>
      </div>
    </el-col>
    <customers-create-view
      v-if="showClientPanel"
      :is-edit="isEdit"
      :old="currentItemEdit"
      @onCreate="test"/>
    <form-modal
      v-if="showModal"
      @closeModal="closeModal">
      <div class="modal-content">
        <el-form
          ref="assignForm"
          @submit.native.prevent="onSubmitAssign">
          <el-form-item label="Vendedor">
            <el-select
              v-model="assign"
              style="width: 100%;"
              placeholder="Selecciona un vendedor">
              <el-option
                v-for="item in users"
                :key="item.id"
                :label="item.firstName + ' ' + item.lastName"
                :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              native-type="submmit">Asignar</el-button>
          </el-form-item>
        </el-form>
      </div>
    </form-modal>
    <form-modal
      v-if="showModalReasign"
      @closeModal="() => { showModalReasign = false }">
      <div class="modal-content">
        <el-form
          ref="reassignForm"
          @submit.native.prevent="onSubmitReassign">
          <el-form-item label="Vendedor">
            <el-select
              v-model="reassign"
              style="width: 100%;"
              placeholder="Selecciona un vendedor">
              <el-option
                v-for="item in users"
                :key="item.id"
                :label="item.firstName + ' ' + item.lastName"
                :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              native-type="submmit">Reasignar</el-button>
          </el-form-item>
        </el-form>
      </div>
    </form-modal>
    <form-modal
      v-if="showModalBranches"
      @closeModal="() => { showModalBranches = false }">
      <div class="modal-content">
        <el-form
          ref="assignForm"
          @submit.native.prevent="onSubmitAssignBranch">
          <el-form-item label="Sucursal">
            <el-select
              v-model="assignBranch"
              style="width: 100%;"
              placeholder="Selecciona una sucursal">
              <el-option
                v-for="item in branches"
                :key="item.id"
                :label="item.city"
                :value="item.id"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              native-type="submmit">Asignar</el-button>
          </el-form-item>
        </el-form>
      </div>
    </form-modal>
    <form-modal
      v-if="showModalFuse"
      @closeModal="() => { showModalFuse = false }">
      <div class="modal-content">
        <el-form
          ref="fuseForm"
          @submit.native.prevent="onSubmitFuse">
          <el-form-item label="Fusionar cliente">
            <el-autocomplete
              v-model="assignFuse"
              :fetch-suggestions="querySearch"
              style="width: 100%;"
              placeholder="Selecciona un cliente"
              @select="handleSelect">
              <template slot-scope="{ item }">
                <div class="value">{{ item.id + ' - ' + item.firstName + ' ' + item.lastName }}</div>
              </template>
            </el-autocomplete>
            <el-checkbox v-model="isMain">Es principal</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              native-type="submmit">Asignar</el-button>
          </el-form-item>
        </el-form>
      </div>
    </form-modal>
  </el-row>
</template>

<script>
import CustomersList from '@/modules/customers/customers-list'
import CustomersHeader from '@/modules/customers/customers-header'
import CustomersTabs from '@/modules/customers/customers-tabs'
import CustomersHeaderStick from '@/modules/customers/_shared/customers-header-stick'
import CustomersCreateView from '@/views/app/customers/customers-create-view'
import CreateTracking from '@/views/app/tracings/tracings-create-view'
import CustomersGuards from '@/guards/customers.guards'
import FormModal from '@/components/_shared/form-modal'
import http from '@/services/http.service'

export default {
  name: 'CustomersContentView',
  components: {
    CustomersList,
    CustomersHeader,
    CustomersTabs,
    CustomersHeaderStick,
    CustomersCreateView,
    CreateTracking,
    FormModal
  },
  props: {
    newClientItem: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      scroll: 0,
      showStick: false,
      currentItemEdit: null,
      isEdit: false,
      keyList: 0,
      showModal: false,
      showModalReasign: false,
      showModalBranches: false,
      showModalFuse: false,
      fullscreenLoading: false,
      assign: '',
      reassign: '',
      assignBranch: '',
      assignFuse: '',
      idAssignFuse: null,
      itemAssign: null,
      itemReassign: null,
      itemAssignBranch: null,
      itemAssignFuse: null,
      links: [],
      isMain: false,
      limitCustomer: 50,
      loading: false
    }
  },
  computed: {
    customers () {
      return this.$store.getters['customers/items']
    },
    customer () {
      return this.$store.getters['customers/item']
    },
    pager () {
      return this.$store.getters['customers/pagination']
    },
    showClientPanel () {
      return this.$store.getters['app/showClientPanel']
    },
    currentCustomer () {
      if (this.$route.params.id) {
        for (let val of this.customers) {
          if (val.id === parseInt(this.$route.params.id)) {
            return val
          }
        }
      } else {
        return this.customers[0]
      }
    },
    users () {
      return this.$store.getters['users/items']
    },
    branches () {
      return this.$store.getters['branches/items']
    }
  },
  mounted () {
    this.links = this.customers
    this.customersItems = this.customers
    this.$el.querySelector('.client-main-list').addEventListener('scroll', event => {
      let loadCustomers = event.target.offsetHeight + event.target.scrollTop
      if (loadCustomers > event.target.scrollHeight - 500 && !this.loading && this.customers.length !== parseInt(this.pager.total)) {
        this.loading = true
        this.limitCustomer += 50
        let _filters = {}
        if (!this.$route.query.typeSearch || this.$route.query.typeSearch === 'name') {
          _filters['filters[where][firstName][contains]'] = this.$route.query.search
          _filters['filters[orWhere][lastName][contains]'] = this.$route.query.search
        } else {
          _filters['filters[where][company][contains]'] = this.$route.query.search
        }
        this.$store.dispatch('customers/query', {
          ..._filters,
          limit: this.limitCustomer,
          sort: 'firstName ASC'
        })
          .then(response => {
            // this.customersItems.push(...response.data.items)
          })
          .finally(() => {
            this.loading = false
          })
      }
    })
  },
  methods: {
    querySearch (queryString, cb) {
      var links = this.links
      var results = queryString ? links.filter(this.createFilter(queryString)) : links
      cb(results)
    },
    createFilter (queryString) {
      return (link) => {
        let name = `${link.firstName} ${link.lastName}`
        return (name.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    closeModal () {
      this.showModal = false
    },
    scrollEvent (e) {
      if (e.srcElement.scrollTop > 100) {
        this.showStick = true
      } else if (e.srcElement.scrollTop < 100) {
        this.showStick = false
      }
    },
    onEdit (val) {
      this.currentItemEdit = val
      this.isEdit = true
      this.$store.dispatch('app/toggleClientPanel')
    },
    onAssignBranch (val) {
      this.itemAssignBranch = val
      this.assignBranch = val.branchId
      this.fullscreenLoading = true
      this.$store.dispatch('branches/query', {
        limit: 1000
      })
        .finally(() => {
          this.fullscreenLoading = false
        })
      this.showModalBranches = true
    },
    onAssign (val) {
      this.itemAssign = val
      this.fullscreenLoading = true
      this.$store.dispatch('users/query', {
        limit: 1000
      })
        .finally(() => {
          this.fullscreenLoading = false
        })
      this.showModal = true
    },
    onReassign (val) {
      this.itemReassign = val
      this.reassign = val.userId
      this.fullscreenLoading = true
      this.$store.dispatch('users/query', {
        limit: 1000
      })
        .finally(() => {
          this.fullscreenLoading = false
        })
      this.showModalReasign = true
    },
    onFuse (val) {
      this.fullscreenLoading = true
      this.itemAssignFuse = val
      http.get(process.env.API_URL + 'customers?limit=5000&sort=firstName+ASC')
        .then(response => {
          this.links = response.data.items
        })
        .finally(() => {
          this.showModalFuse = true
          this.fullscreenLoading = false
        })
    },
    onDelete (val) {
      this.$confirm('¿Esta seguro que desea eliminar el cliente?', 'Warning', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        http.delete(process.env.API_URL + 'customers/' + val.id)
          .then(response => {
            this.$message.success('Cliente eliminado con éxito')
            return this.$store.dispatch('customers/query', { ...this.$route.query, limit: 1000, sort: 'firstName ASC' })
          })
          .finally(() => {
            this.fullscreenLoading = false
          })
      }).catch(() => {
      })
    },
    onSubmitAssign () {
      this.fullscreenLoading = true
      http.put(process.env.API_URL + 'customers-assign/' + this.itemAssign.id, { userId: this.assign })
        .then(response => {
          this.$message.success('Cliente editado con éxito')
          return this.$store.dispatch('customers/query', { ...this.$route.query, limit: 1000, sort: 'firstName ASC' })
        })
        .catch(e => {
          this.$message.error('No pudo ser editado el cliente')
        })
        .finally(() => {
          this.fullscreenLoading = false
          this.showModal = false
        })
    },
    onSubmitReassign () {
      this.fullscreenLoading = true
      http.put(process.env.API_URL + 'reassignment/customer/' + this.itemReassign.id, { sellerId: this.reassign })
        .then(response => {
          this.$message.success('Cliente editado con éxito')
          return this.$store.dispatch('customers/query', { ...this.$route.query, limit: 1000, sort: 'firstName ASC' })
        })
        .catch(e => {
          this.$message.error('No pudo ser editado el cliente')
        })
        .finally(() => {
          this.fullscreenLoading = false
          this.showModalReasign = false
        })
    },
    onSubmitAssignBranch () {
      this.fullscreenLoading = true
      http.put(process.env.API_URL + 'customers-assign/' + this.itemAssignBranch.id, { branchId: this.assignBranch })
        .then(response => {
          this.$message.success('Sucursal asignada con éxito')
          return this.$store.dispatch('customers/query', { ...this.$route.query, limit: 1000, sort: 'firstName ASC' })
        })
        .catch(e => {
          this.$message.error('La sucursal no pudo ser asignada')
        })
        .finally(() => {
          this.fullscreenLoading = false
          this.showModalBranches = false
        })
    },
    onSubmitFuse () {
      this.fullscreenLoading = true
      let data = {
        mainCustomerId: this.isMain ? this.idAssignFuse : this.itemAssignFuse.id,
        secondaryCustomerId: this.isMain ? this.itemAssignFuse.id : this.idAssignFuse
      }
      http.post(process.env.API_URL + 'customers-mix/', data)
        .then(response => {
          this.$message.success('Clientes fusionados exitosamente')
          return this.$store.dispatch('customers/query', { ...this.$route.query, limit: 1000, sort: 'firstName ASC' })
        })
        .catch(e => {
          this.$message.error('Los clientes no pudieron ser fusionados')
        })
        .finally(() => {
          this.fullscreenLoading = false
          this.showModalFuse = false
          this.assignFuse = null
        })
    },
    handleSelect (item) {
      this.assignFuse = item.firstName + item.lastName
      this.idAssignFuse = item.id
    },
    onCreate () {
      this.isEdit = false
    },
    test (id) {
      this.$store.dispatch('customers/query', {limit: 1000, sort: 'firstName ASC'})
        .then(({data}) => {
          this.$router.push({name: 'customers-info', params: {id: id}})
          this.$store.dispatch('app/toggleClientPanel')
          if (this.keyList === 0) {
            this.keyList = this.keyList + 1
          } else {
            this.keyList = this.keyList - 1
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  beforeRouteUpdate: CustomersGuards.guardTabMenu
}
</script>

<style lang="scss" scoped>
  .main-container{
    height: 100%;
    width: 100%;
    overflow: hidden;
    .client-main-list{
      height: calc(100% - 60px);
      border-right: 1px solid $border-primary;
      position: relative;
      background-color: #ffffff;
      overflow: auto;
    }
    .container-section-main {
      height: calc(100% - 60px);
      position: relative;
      background-color: $secondary;
      overflow: auto;
      .client-main-section{
        height: calc(100% - 60px);
        padding: 30px;
        overflow: auto;
      }
    }
  }
  .modal-content {
    padding: 50px 30px 30px 30px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/views/app/customers/customers-content-view.vue